export default __webpack_public_path__ + "static/media/AMAZON2.afd9cae8.png";